import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, linkedSignal, model, Output } from '@angular/core';
import { NgClass } from '@angular/common';

import { FileDragDropDirective } from '@shared/directives';
import { AlertService } from '@shared/services';

@Component({
  selector: 'app-file-upload',
  imports: [FileDragDropDirective, NgClass],
  templateUrl: './file-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadComponent {
  private readonly alertService = inject(AlertService);

  @Output() cleared = new EventEmitter<void>();

  label = input<string>('Subir archivo');
  labelForId = input<string>('fileUpload');
  icon = input<string>('upload_file');
  title = input<string>('Arrastra y suelta un archivo aquí');
  isRequired = input<boolean>(false);
  allowedFiles = input.required<string>(); // MIME type: 'application/pdf, image/jpeg, image/png'
  extensions = input.required<string>(); // Extensions: '.pdf .jpeg .png .docx'

  fileMaxSize = input<number>(10_000_000); // 10_000_000 Bytes = 10 Megabyte
  file = model<File | null>(null);
  fileName = input<string | null>(null);
  attachmentName = linkedSignal(this.fileName);
  fileMaxSizeMb = computed(() => this.fileMaxSize() / 1_000_000);

  uploadFileDrop(fileList: FileList) {
    const file: File = fileList[0];
    this.validarFile(file);
  }

  uploadFile(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    const file: File = files[0];
    this.validarFile(file);
    target.value = '';
  }

  validarFile(file: File) {
    if (!file) {
      return;
    }

    const allowedFiles = this.allowedFiles().replace(/\s/g, '');
    if (!allowedFiles.split(',').includes(file.type)) {
      this.alertService.showMessageCustom('Advertencia', 'El tipo de archivo no es permitido', {
        icon: 'brightness_alert',
        class: 'text-warning',
      });
      return;
    }

    if (file.size > this.fileMaxSize()) {
      // 10_000_000 Bytes = 10 Megabyte
      this.alertService.showMessageCustom(
        'Advertencia',
        `El tamaño de la archivo supera el límite permitido (${this.fileMaxSizeMb()}mb)`,
        {
          icon: 'brightness_alert',
          class: 'text-warning',
        }
      );
      return;
    }

    this.file.set(file);
  }

   clearFile() {
    console.log('borrar')
  this.file.set(null);     
  this.attachmentName.set(null);
  this.cleared.emit();
}
}
